import { configureStore, combineReducers } from '@reduxjs/toolkit';
import snackbarReducer from '../features/snackbar/snackbarSlice';
import breadcrumbReducer from '../features/breadcrumb/breadcrumbSlice';
import alertReducer from '../features/alert/alertSlice';
import bucketsReducer from '../features/bucket/bucketSlice';
import valuesReducer from '../features/form/valuesSlice';
import errorsReducer from '../features/form/errorsSlice';
import alertsReducer from '../features/form/alertsSlice';
import initialOptionsReducer from '../features/form/initialOptionsSlice';
const middlewares = [];
if (process.env.NODE_ENV === 'development') {
    const { logger } = require(`redux-logger`);
    middlewares.push(logger);
}
export const store = configureStore({
    reducer: {
        breadcrumb: breadcrumbReducer,
        snackbars: snackbarReducer,
        alerts: alertReducer,
        forms: combineReducers({
            values: valuesReducer,
            errors: errorsReducer,
            alerts: alertsReducer,
            initialOptions: initialOptionsReducer,
        }),
        buckets: bucketsReducer,
    },
    middleware: (getDefaultMiddleware) => {
        return [...getDefaultMiddleware(), ...middlewares];
    },
});
